import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Shannon W.',
      rating: 5,
      text: 'Adam showed up on time, did the job quickly, and was polite and professional. Would definitely use again. The quality of work exceeded our expectations and the countertops look absolutely stunning in our kitchen.',
      location: 'Salt Lake City, UT'
    },
    {
      name: 'Jane D.',
      rating: 5,
      text: 'Outstanding service from start to finish. The team was professional, the installation was flawless, and our new countertops have completely transformed our kitchen. Highly recommend A-One Solid Surfacing!',
      location: 'Park City, UT'
    },
    {
      name: 'Lukas A.',
      rating: 5,
      text: 'Exceptional craftsmanship and attention to detail. They helped us choose the perfect material and the installation was seamless. Our commercial space looks incredible thanks to their expertise.',
      location: 'West Valley City, UT'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our <span className="text-amber-600">Customers Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real reviews from satisfied homeowners and businesses
          </p>
        </div>

        {/* Testimonial Slider */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            {/* Stars */}
            <div className="flex justify-center mb-6">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-3xl text-amber-500"></i>
              ))}
            </div>

            {/* Quote */}
            <blockquote className="text-xl md:text-2xl text-gray-700 text-center mb-8 leading-relaxed">
              "{testimonials[activeIndex].text}"
            </blockquote>

            {/* Author */}
            <div className="text-center">
              <div className="font-bold text-xl text-gray-900 mb-1">
                {testimonials[activeIndex].name}
              </div>
              <div className="text-gray-600">
                {testimonials[activeIndex].location}
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center space-x-3 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === activeIndex ? 'bg-amber-600 w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Google Review CTA */}
          <div className="text-center mt-12">
            <a 
              href="https://search.google.com/local/writereview?placeid=ChIJ6Qo5-_2OUocRE5Gv-tnbkQs"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-gray-600 hover:text-amber-600 transition-colors"
            >
              <span className="font-medium">Read more reviews on</span>
              <i className="ri-google-fill text-2xl"></i>
              <span className="font-bold">Google</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}